<template>
	<div class="menu-container flex flex-column width-100 justify-space-between">
		<perfect-scrollbar class="flex flex-column pb-5 content-container">
			<slot />
		</perfect-scrollbar>
		<div class="footer-container width-100 flex-centerize">
			<v-btn @click="onClose" class="close-button">Back to editing step</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FloatingAccordionMenu',
	methods: {
		onClose() {
			this.$emit('closeMenu');
		},
	},
};
</script>

<style scoped lang="scss">
$footer-height: 68px;
.menu-container {
	top: 60px;
	z-index: 51;
	max-height: 70%;
	position: absolute;
	background: var(--bg-color);

	.content-container {
		margin-bottom: $footer-height;
	}

	.footer-container {
		bottom: 0px;
		position: absolute;
		height: $footer-height;
		border-radius: 0px 0px 8px 8px;
		box-shadow: 0px -3px 6px var(--shadow-color);

		.close-button {
			height: 38px !important;
			font-size: 14px !important;
			font-weight: medium !important;
			color: var(--bg-color) !important;
			background-color: var(--primary-color) !important;
		}
	}
}
</style>
